
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage-for-winter",
      function () {
        return require("private-next-pages/storage-for-winter/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage-for-winter"])
      });
    }
  